import { FC, PropsWithChildren, useMemo } from 'react'
import { createGlobalStyle, ThemeProvider as SCThemeProvider } from 'styled-components'
import defaultTheme, { IThemeOverrides } from './theme'
import antdStyleOverwrites from './styles/antd'
import phoneInputStyleOverwrites from './styles/phone-input'
import animationStyles from './styles/animations'
import { color } from './mixins'

const GlobalStyles = createGlobalStyle`
	html, body, #__next {
		min-height: 100%;
	}

	a, a:hover {
		color: ${color('primary')};
	}

	::selection {
		background: ${color('primary')};
	}

	h1, h2, h3, h4, h5, h6 {
		margin-top: 0;
	}

	${antdStyleOverwrites}
	${phoneInputStyleOverwrites}
	${animationStyles}
`

const ThemeProvider: FC<PropsWithChildren<IThemeOverrides>> = ({
	children,
	primaryColor,
	contrastColor,
	pageBackgroundColor,
}) => {
	const theme = useMemo(
		() => ({
			...defaultTheme,
			colors: {
				...defaultTheme.colors,
				primary: {
					...defaultTheme.colors.primary,
					'500': primaryColor || defaultTheme.colors.primary['500'],
					'800': pageBackgroundColor || defaultTheme.colors.primary['800'],
					'900': contrastColor || defaultTheme.colors.primary['900'],
				},
			},
		}),
		[contrastColor, primaryColor, pageBackgroundColor]
	)

	return (
		<SCThemeProvider theme={theme}>
			<GlobalStyles />
			{children}
		</SCThemeProvider>
	)
}

export default ThemeProvider
